import React from 'react';
import { Box, Card, SkeletonLoader, Typography } from '@drone-js/core';
import { useSelector } from 'react-redux';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import { FeatureName } from 'core/constant/FeatureName';
import Feature from 'component/common/Experiment/Feature';

const SortAndFilterSidebarPlaceholder: React.FC = React.memo(() => {
    const cms = useSelector(selectCmsFromBootstrap);
    const NO_OF_LOADER = 10;

    const loaderLabel = cms[326495];

    return (
        <Card p="16" pb="32" data-testid="activities-sort-and-filter-sidebar-placeholder" variant="outlined" type="non-interactive">
            <Box display="flex" flexDirection="column">
                <Typography mb="16" data-testid="activities-sort-heading" variant="heading-default" role="heading" aria-level={2} aria-label={cms[146541]}>
                    {cms[146541]}
                </Typography>
                <SkeletonLoader label={loaderLabel} shape="rectangle" width="25%" height="20px" mb="12" />
                <SkeletonLoader label={loaderLabel} shape="rectangle" width="50%" height="20px" mb="12" />
                <SkeletonLoader label={loaderLabel} shape="rectangle" width="60%" height="20px" mb="16" />

                <Feature.On name={FeatureName.SubcategoryFilter}>
                    <Typography mb="16" data-element-name="activities-star-heading" variant="heading-default" role="heading" aria-level={2} aria-label={cms[350451]}>
                        {cms[350451]}
                    </Typography>
                    {Array.from({ length: NO_OF_LOADER }, (_, i) => {
                        return (
                            <React.Fragment key={i}>
                                <SkeletonLoader label={loaderLabel} shape="rectangle" width="80%" height="20px" mb="12" />
                            </React.Fragment>
                        );
                    })}
                </Feature.On>

                <Typography mb="16" data-element-name="activities-price-heading" variant="heading-default" role="heading" aria-level={2} aria-label={cms[146542]}>
                    {cms[146542]}
                </Typography>
                <SkeletonLoader label={loaderLabel} shape="rectangle" width="80%" height="20px" mb="12" />

                <Typography mb="16" data-element-name="activities-star-heading" variant="heading-default" role="heading" aria-level={2} aria-label={cms[146543]}>
                    {cms[146543]}
                </Typography>
                <SkeletonLoader label={loaderLabel} shape="rectangle" width="50%" height="20px" mb="12" />
                <SkeletonLoader label={loaderLabel} shape="rectangle" width="40%" height="20px" mb="12" />
                <SkeletonLoader label={loaderLabel} shape="rectangle" width="30%" height="20px" mb="12" />
                <SkeletonLoader label={loaderLabel} shape="rectangle" width="20%" height="20px" mb="12" />
                <SkeletonLoader label={loaderLabel} shape="rectangle" width="10%" height="20px" mb="12" />
                <SkeletonLoader label={loaderLabel} shape="rectangle" width="40%" height="20px" mb="16" />

                <Feature.On name={FeatureName.NewFilters}>
                    <Typography mb="16" data-element-name="activities-booking-feature-heading" variant="heading-default" role="heading" aria-level={2} aria-label={cms[411347]}>
                        {cms[411347]}
                    </Typography>
                    <SkeletonLoader label={loaderLabel} shape="rectangle" width="60%" height="20px" mb="12" />
                    <SkeletonLoader label={loaderLabel} shape="rectangle" width="60%" height="20px" mb="12" />
                    <SkeletonLoader label={loaderLabel} shape="rectangle" width="60%" height="20px" mb="16" />
                </Feature.On>

                <Typography mb="16" data-element-name="activities-duration-heading" variant="heading-default" role="heading" aria-level={2} aria-label={cms[146544]}>
                    {cms[146544]}
                </Typography>
                <SkeletonLoader label={loaderLabel} shape="rectangle" width="60%" height="20px" mb="12" />
                <SkeletonLoader label={loaderLabel} shape="rectangle" width="60%" height="20px" mb="12" />
                <SkeletonLoader label={loaderLabel} shape="rectangle" width="60%" height="20px" mb="16" />

                <Typography mb="16" data-element-name="activities-categories-heading" variant="heading-default" role="heading" aria-level={2}>
                    {cms[252193]}
                </Typography>
                <SkeletonLoader label={loaderLabel} shape="rectangle" width="70%" height="20px" mb="12" />
                {Array.from({ length: NO_OF_LOADER }, (_, i) => {
                    return (
                        <React.Fragment key={i}>
                            <SkeletonLoader label={loaderLabel} shape="rectangle" width="80%" height="20px" mb="12" />
                        </React.Fragment>
                    );
                })}
            </Box>
        </Card>
    );
});

SortAndFilterSidebarPlaceholder.displayName = 'SortAndFilterSidebarPlaceholder';

export default SortAndFilterSidebarPlaceholder;
